/* eslint-disable react/prop-types */
import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";

const classes = makeStyles(styles);

class AddVariant extends Component {
  state = {
    productId: 0,
    mediaTypes: [],
    osTypes: [],
    viewsValidity: [],
    media_id: "",
    os_id: "",
    view_id: "",
    redirect: false,
    adding: false,
    aAlert: false,
    bAlert: false,
    cAlert: false,
    price: ""
  };
  componentDidMount() {
    this.setState({
      productId: this.props.match.params.id
    });
    axios.get("https://admin.akclasses.in/api/indexall_media").then(resp => {
      //console.log(resp.data);
      this.setState({
        mediaTypes: resp.data
      });
    });
    axios.get("https://admin.akclasses.in/api/indexall_os").then(resp => {
      //console.log(resp.data);
      this.setState({
        osTypes: resp.data
      });
    });
    axios.get("https://admin.akclasses.in/api/indexall_view").then(resp => {
      //console.log(resp.data);
      this.setState({
        viewsValidity: resp.data
      });
    });
  }
  variantSubmit = e => {
    e.preventDefault();
    let payLoad = {
      media_type_id: parseInt(this.state.media_id),
      os_type_id: parseInt(this.state.os_id),
      view_and_validity_id: parseInt(this.state.view_id),
      price: this.state.price
    };
    if (this.state.media_id === "") {
      this.setState({
        aAlert: true
      });
    } else if (this.state.os_id === "") {
      this.setState({
        bAlert: true
      });
    } else if (this.state.view_id === "") {
      this.setState({
        cAlert: true
      });
    } else {
      this.setState({ adding: true });
      axios
        .post(
          // "https://admin.akclasses.in/api/variant/create/" +
          "https://admin.akclasses.in/api/storeVariantCommission/" +
            this.state.productId,
          payLoad
        )
        .then(() => {
          //console.log(resp.data);
          this.setState({
            redirect: true,
            adding: false
          });
        });
    }
  };
  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: "/admin/coursevariants/" + this.state.productId
          }}
        />
      );
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Product Key Added!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Course Variant</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.variantSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Media Type
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.media_id}
                            inputProps={{
                              name: "media_id",
                              id: "simple-select",
                              onChange: e => {
                                this.setState({
                                  media_id: e.target.value,
                                  aAlert: false
                                });
                              }
                            }}
                          >
                            {this.state.mediaTypes.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.media_type}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {this.state.aAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            OS Type
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.os_id}
                            inputProps={{
                              name: "os_id",
                              id: "simple-select",
                              onChange: e => {
                                this.setState({
                                  os_id: e.target.value,
                                  bAlert: false
                                });
                                // //console.log(e.target.value);
                              }
                            }}
                          >
                            {this.state.osTypes.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.os_type}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {this.state.bAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Views & Validity
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.view_id}
                            inputProps={{
                              name: "view_id",
                              id: "simple-select",
                              onChange: e => {
                                this.setState({
                                  view_id: e.target.value,
                                  cAlert: false
                                });
                                // //console.log(e.target.value);
                              }
                            }}
                          >
                            {this.state.viewsValidity.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.view_and_validity}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {this.state.cAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Price"
                          id="float"
                          inputProps={{
                            type: "number",
                            required: true,
                            onChange: e =>
                              this.setState({ price: e.target.value })
                          }}
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4}>
                        <Button className="" color="warning" type="submit">
                          {this.state.adding ? <Loader /> : "Add Variant"}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/coursesmaster"
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default AddVariant;
